var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrokenHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 44.188l-19.176-20a11.344 11.344 0 01-2.126-13.102v0a11.346 11.346 0 0118.17-2.948L24 11.268l3.132-3.13a11.346 11.346 0 0116.046 16.044L24 44.188z",
    stroke: "#007DBC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 11.268l5.875 5.8a1.501 1.501 0 01-.498 2.46L19.6 23.446a1.502 1.502 0 00-.114 2.736l7.85 3.918a1.5 1.5 0 01.752 1.816L24 44.188",
    stroke: "#007DBC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgBrokenHeart;